var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Header, Message } from "semantic-ui-react";
import { AsyncButton } from "@iscr/views/UIelems/AsyncButton";
import { useTRPC } from "@iscr/xAppLib/context/QueryProvider";
import { useMutation } from "@tanstack/react-query";
import { Link } from "react-router";
import { useMimsRegistrationState } from "@iscr/mims/context/MimsRegistrationProvider";
function Layout({ children }) {
    return (_jsxs("div", { className: "mt-12", children: [_jsx("hr", {}), _jsx(Header, { as: "h3", children: "MIMS Enrolment" }), children] }));
}
export function MimsEnrollment({ user, onEnrolled }) {
    var _a, _b, _c, _d;
    const trpc = useTRPC();
    const enrol = useMutation(trpc.mims.admin.users.register.mutationOptions());
    const { can } = useMimsRegistrationState();
    const mims = (_a = user === null || user === void 0 ? void 0 : user.xtra) === null || _a === void 0 ? void 0 : _a.mims;
    if (mims && "type" in mims) {
        return (_jsxs(Layout, { children: [_jsx("p", { children: "Enrolled for MIMS access." }), mims.type === "provider" && can("mims:users:list") && (_jsxs("p", { children: [_jsx(Link, { to: "/admin/mims/user-management", state: { userId: mims.user_id }, children: "Manage enrolment" }), "."] }))] }));
    }
    if (!can("mims:user:register")) {
        return null;
    }
    if (!((_c = (_b = user.auth) === null || _b === void 0 ? void 0 : _b.customClaims) === null || _c === void 0 ? void 0 : _c.doc) && !((_d = user.claims) === null || _d === void 0 ? void 0 : _d.doc)) {
        return null;
    }
    return (_jsxs(Layout, { children: [_jsx(AsyncButton, { type: "button", onClick: () => __awaiter(this, void 0, void 0, function* () {
                    const confirmed = yield app.confirm("Are you sure you want to enroll this user in MIMS?", _jsxs("div", { children: [_jsx("p", { children: "Before the user can use MIMS they will need to agree to the MIMS EULA" }), _jsx("p", { children: "Once a user is registered, they can not be removed; only deactivated." })] }));
                    if (confirmed !== "yes") {
                        return;
                    }
                    yield enrol.mutateAsync({
                        userId: user.uid,
                    });
                    onEnrolled();
                }), children: "Enroll in MIMS" }), enrol.error && (_jsx(Message, { visible: true, error: true, header: "Error enrolling user in MIMS", content: enrol.error.message }))] }));
}
